angular.module('unica_invitation.invitation_services')

.factory('InvitationCreateService', function ($http, getBaseApiURL) {

	var invitationCreateService = {};

	invitationCreateService.inviteUser = function (invitationData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/create',
			data: invitationData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitations;
			}

		});

	};

	return invitationCreateService;
});